import React from "react";
import FormSwitchWithText from "../yoello-lib/modules/dynamicForms/FormComponents/FormSwitchWithText";
import FormTextBox from "../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox";
import FormInputGenerator from "../yoello-lib/modules/dynamicForms/FormComponents/FormInputGenerator";
import IDynamicFormRow from "../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";
import { DiscountType } from "../components/discounts/ui/DiscountType";
import { MinOrderAddon } from "../components/discounts/ui/MinOrderAddon";
import Styles from "../scss/formFields.module.scss"
import { IDiscountType } from "../yoello-lib/modules/interfaces/IDiscounts";
import StylesDisc from "../scss/discounts.module.scss";

export function discontsForm(isEdit: boolean, selectedType: IDiscountType, t: (key: string) => string, currency: string, codeValidation: Function): IDynamicFormRow[] {
    return [
        {
            label: "discounts.form.code",
            keyName: "code",
            Component: FormInputGenerator,
            disabled: isEdit,
            registerOptions:
            {
                required: true,
                validate: {
                    validateCode,
                    validateCodeOnApply
                }
            },
            formProps: {
                className: StylesDisc.discountsTypeContainer,
                isEdit
            },
            inputProperties: {
                placeholder: t('discounts.form.placeholder'),
            },
            gridColumnOptions: {
                formCol: isEdit ? 8 : 12
            },
            className: Styles.TextBoxWithAddon
        }, {
            label: "discounts.form.enabled",
            Component: FormSwitchWithText,
            keyName: "enabled",
            gridColumnOptions: {
                formCol: isEdit ? 4 : 12
            },
            className: Styles.FormSwitchWithText
        },
        {
            label: "discounts.form.discountValue",
            keyName: "value",
            Component: FormTextBox,
            disabled: isEdit,
            registerOptions:
            {
                required: true,
            },
            inputProperties: {
                type: 'number',
                placeholder: selectedType === IDiscountType.PERCENTAGE ? "0%" : `${currency}0`,
                inputProps: { step: 0.001, min: 0 },
                InputProps: {
                    endAdornment: <DiscountType isEdit={isEdit} />
                },
            },
            gridColumnOptions: {
                formCol: 12
            },
            className: Styles.TextBoxWithAddon
        },
        {
            label: "discounts.form.description",
            keyName: "description",
            Component: FormTextBox,
            disabled: isEdit,
            registerOptions:
            {
                required: true,
            },
            inputProperties: {
                type: 'text',
                multiline: true,
                rows: 4,
            },
            gridColumnOptions: {
                formCol: 12
            },
        }
        ,
        {
            label: "discounts.form.maxNumberOfUses",
            keyName: "max_number_of_uses",
            Component: FormTextBox,
            disabled: isEdit,
            formProps: {
                tooltip: "discounts.form.maxTooltip"
            },
            inputProperties: {
                type: 'number',
                inputProps: { min: 0 },
            },
            gridColumnOptions: {
                formCol: 6
            },
        },
        {
            label: "discounts.form.maxUsesPerCustomer",
            keyName: "max_uses_per_consumer",
            Component: FormTextBox,
            formProps: {
                tooltip: "discounts.form.maxCustomersTooltip"
            },
            disabled: isEdit,
            inputProperties: {
                type: 'number',
                inputProps: { min: 0 },
            },
            gridColumnOptions: {
                formCol: 6
            },
        },
        {
            label: "discounts.form.minOrderValue",
            keyName: "minimum_order_value",
            Component: FormTextBox,
            disabled: isEdit,
            inputProperties: {
                type: 'number',
                inputProps: { min: 0 },
                InputProps: {
                    endAdornment: <MinOrderAddon />
                },
            },
            gridColumnOptions: {
                formCol: 6
            },
            className: Styles.TextBoxWithAddonReverse
        },
        {
            label: "",
            keyName: "",
            Component: () => null,
            disabled: isEdit,
            gridColumnOptions: {
                formCol: 6
            },
        },
    ];
    function validateCode(value: any) {
        try {
            if (value.length > 12) {
                return t("discounts.Errors.MaxLength") as string
            }
            const regex = new RegExp(/^[a-zA-Z0-9_]*$/);
            if (!regex.test(value)) {
                return t("discounts.Errors.InvalidDiscount") as string
            }
            return true;
        } catch (error) {
            return t("discounts.Errors.UsedDiscount") as string
        }
    }
    function validateCodeOnApply(value: any) {
        if (value) {
            const isValid = codeValidation(value);
            if (!isValid) {
                return t("discounts.Errors.UsedDiscount") as string
            }
        }
        return true
    }
}